<template>
  <div 
    class="badge" 
    data-color="light"
  >
    <template v-if="isScope">
      <div 
        :style="labelStyle" 
        class="badge-text-left"
      >
        {{ scopeName.first }}
      </div>
      <div 
        :style="secondScopeStyle" 
        class="badge-text-right"
      >
        {{ scopeName.second }}
      </div>
    </template>
    <div 
      v-else
      :style="labelStyle" 
      class="badge-text" 
    >
      {{ labelName }}
    </div>
  </div>
</template>

<script>
export default {
    props: {
        labelName: {
            type: String,
            required: true,
        },
        backgroundColor: {
            type: String | null,
            required: true,
        },
    },

    computed: {
        isScope() {
            const filter = ['::'];
            return _.some(filter, el => _.includes(this.labelName, el));
        },

        color() {
            let color;

            if (this.backgroundColor) {
                color = this.backgroundColor;
            } else {
                color = '#000000';
            }

            return color;
        },

        labelStyle() {
            return {
                backgroundColor: this.color,
            };
        },

        secondScopeStyle() {
            return {
                outline: `2px solid ${this.color}`,
            };
        },

        scopeName() {
            const split = this.labelName.split('::');
            const second = split[split.length - 1];
            const first_data = _.dropRight(split);
            const first = _.join(first_data, '::');

            return {
                first: first,
                second: second,
            };
        },
    },
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/label/label-badge.vue